export default "__VITE_ASSET__BkVF_92s__"